import { render } from "./PricingTier.vue?vue&type=template&id=444a0fec"
import script from "./PricingTier.vue?vue&type=script&lang=js"
export * from "./PricingTier.vue?vue&type=script&lang=js"

import "./PricingTier.vue?vue&type=style&index=0&id=444a0fec&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__